import { notification } from "antd";
import { useEffect, useState } from "react";

import api from "../../../services/api";
import { DefaultSerie } from "../types";

export function useDefaultSerie(visible: boolean, companyId?: number) {
  const [defaultSerie, setDefaultSerie] = useState<DefaultSerie>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible) return;

    const fetchDefaultSerie = async () => {
      try {
        setLoading(true);
        const { data } = await api.get(`company/focus/${companyId}`);

        if (data?.content) {
          const isHomolog = process.env.REACT_APP_ENV === "homolog";
          setDefaultSerie({
            serie: Number(
              isHomolog
                ? data.content.serie_nfce_homologacao
                : data.content.serie_nfce_producao
            ),
            invoiceSequence: Number(
              isHomolog
                ? data.content.proximo_numero_nfce_homologacao
                : data.content.proximo_numero_nfce_producao
            ),
          });
        }
      } catch (e) {
        //@ts-ignore
        const _description = e?.response?.data?.message;
        notification.error({
          message: `Erro ao buscar série/sequência padrão da loja`,
          description: _description,
          duration: 3,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchDefaultSerie();
  }, [visible, companyId]);

  return { defaultSerie, loading };
}
